<template>
  <div :id="uid">
    <van-popup
      v-model="isShow"
      v-bind="$props"
      @open="open"
      @close="close"
      :style="styleOptions"
      >
      <slot>
        <div v-if="content" v-html="content"></div>
      </slot>
    </van-popup>
  </div>
</template>
<script>
import { Popup } from 'vant';
export default {
  name: 'BackPrompt',
  props: {
    ...Popup.props,
    value: {
      type: Boolean,
      default: false
    },
    uid: {
      type: [String, Number],
      default: ''
    },
    subtitle: {
      type: [String, Number],
      default: '提示'
    },
    desc: {
      type: [String, Number],
      default: ''
    },
    styleOptions: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      isShow: false,
      content: ''
    };
  },
  watch: {
    value(val) {
      this.isShow = val;
    }
  },
  methods: {
    open() {
      this.$emit('onOpen', true);
    },
    close() {
      this.$emit('onClose', false);
    },
    onHide() {
      this.$emit('input', false);
    },
    onShow() {
      this.$emit('input', true);
    }
  }

};
</script>